import React, { useEffect, useState } from 'react';
import { User, ChevronDown } from 'lucide-react';
import { motion } from 'framer-motion';
import type { Account } from '../types';
import { getAccountIcon } from '../logic/uiHelpers';
import { dataLayer } from '../../data/dataLayer';
interface ProfileButtonProps {
  account: Account;
  onClick: () => void;
}
export function ProfileButton({
  account,
  onClick
}: ProfileButtonProps) {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const isLearner = account.role === 'learner';
  // Load custom avatar for learners
  useEffect(() => {
    if (isLearner) {
      const loadAvatar = async () => {
        const prefs = await dataLayer.getLearnerPreferences(account.id);
        if (prefs?.avatarUrl) {
          setAvatarUrl(prefs.avatarUrl);
        }
      };
      loadAvatar();
    }
  }, [account.id, isLearner]);
  const Icon = getAccountIcon(account.role);
  return <motion.button onClick={onClick} className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-143" data-mp="1nhv9pj3igah1">
      
      {/* Avatar */}
      {isLearner && avatarUrl ? <img src={avatarUrl} alt={account.displayName} className="w-8 h-8 rounded-full object-cover" data-id="element-144" data-mp="1oiqipyv1wmyo" /> : <div className="w-8 h-8 rounded-full bg-gradient-to-br from-purple-400 to-blue-500 flex items-center justify-center" data-id="element-145" data-mp="1js1tkq6ug22p">
          <Icon className="w-5 h-5 text-white" data-id="element-146" data-mp="1ygeodju73evm" />
        </div>}

      {/* Name and Role */}
      <div className="hidden sm:block text-left" data-id="element-147" data-mp="1ticx4bmm8992">
        <p className="text-sm font-medium text-gray-900" data-id="element-148" data-mp="1thldlz6am1z5">
          {account.displayName}
        </p>
        <p className="text-xs text-gray-500 capitalize" data-id="element-149" data-mp="27gtdyve6zg4x">{account.role}</p>
      </div>

      <ChevronDown className="w-4 h-4 text-gray-400 hidden sm:block" data-id="element-150" data-mp="23giyms4ifdde" />
    </motion.button>;
}